import { errorMessage } from "helpers/utils";
import { call, put, takeEvery } from "redux-saga/effects";
import BusinessUnitService from "services/BusinessUnitService";
import {
  activeBusinessUnitFail,
  activeBusinessUnitSuccess,
  createBusinessUnitFail,
  createBusinessUnitSuccess,
  detailBusinessUnitFail,
  detailBusinessUnitSuccess,
  listBusinessUnitFail,
  listBusinessUnitSuccess,
  updateBusinessUnitSuccess,
  updateBusinessUnitFail,
} from "store/actions";
import { deleteBusinessUnitFail, deleteBusinessUnitSuccess } from "./actions";
import {
  BUSINESS_UNIT_CREATE,
  BUSINESS_UNIT_DETAIL,
  BUSINESS_UNIT_LIST,
  BUSINESS_UNIT_UPDATE,
  BUSINESS_UNIT_DELETE
} from "./actionTypes";
function* fetchListBusinessUnit({ payload }) {
  try {
    const response = yield call(BusinessUnitService.listBusinessUnit, payload);
    yield put(listBusinessUnitSuccess(response));
  } catch (error) {
    yield put(listBusinessUnitFail(errorMessage(error)));
  }
}

function* onUpdateBusinessUnit({ payload }) {
  try {
    const response = yield call(BusinessUnitService.updateBusinessUnit, payload);
    yield put(updateBusinessUnitSuccess(response));
  } catch (error) {
    yield put(updateBusinessUnitFail(errorMessage(error)));
  }
}
function* onCreateBusinessUnit({ payload }) {
  try {
    const response = yield call(BusinessUnitService.createBusinessUnit, payload);
    yield put(createBusinessUnitSuccess(response));
  } catch (error) {
    yield put(createBusinessUnitFail(errorMessage(error)));
  }
}

function* onDetailBusinessUnit({ payload }) {
  try {
    const response = yield call(BusinessUnitService.detailBusinessUnit, payload);
    yield put(detailBusinessUnitSuccess(response));
  } catch (error) {
    yield put(detailBusinessUnitFail(errorMessage(error)));
  }
}

function* onDeleteBusinessUnit({ payload }) {
  try {
    const response = yield call(BusinessUnitService.deleteBusinessUnit, payload);
    yield put(deleteBusinessUnitSuccess(response));
  } catch (error) {
    yield put(deleteBusinessUnitFail(errorMessage(error)));
  }
}

function* onActiveBusinessUnit({ payload }) {
  try {
    const response = yield call(BusinessUnitService.activeBusinessUnit, payload);
    yield put(activeBusinessUnitSuccess(response));
  } catch (error) {
    yield put(activeBusinessUnitFail(errorMessage(error)));
  }
}

function* userManagementSaga() {
  yield takeEvery(BUSINESS_UNIT_LIST, fetchListBusinessUnit);
  yield takeEvery(BUSINESS_UNIT_CREATE, onCreateBusinessUnit);
  yield takeEvery(BUSINESS_UNIT_DETAIL, onDetailBusinessUnit);
  yield takeEvery(BUSINESS_UNIT_UPDATE, onUpdateBusinessUnit);
  yield takeEvery(BUSINESS_UNIT_DELETE, onDeleteBusinessUnit);
}

export default userManagementSaga;
